const dictionary = { 
    common:{
        next: "Next",
        test: "Start evaluation", 
        closed: "Close",
        end_evaluation:"End evaluation",
        start:"Start",
        start_test:'Start test',
        continue:'Continue',
        accept:'Accept',
        loading:'Loading...',
        saving:'Saving...',
        next_page:'Next page',
        retry: "Try now",
        retry_late: "Try later"
    },
    start: {
        title: 'Welcome!',
        description: 'We are loading your information, please wait.',
        no_id: 'Oops! There has been an issue.',
        error_description: 'Please contact the person who sent you the email for assistance.',
        welcome_test: 'Welcome to the Mabe Evaluation!',
        welcome_description_no_id: 'If you wish to start an evaluation, please contact the person who sent you this link.',
        welcome_description: 'This evaluation is no longer available.',
    },
    welcome: {
        title: "Welcome!",
        subtitle: "You are about to complete a series of evaluations.",
        desc1: "You need an average of 30 minutes, think about your answers and do not rush.",
        desc2: "Please choose the phrase that best describes what you would do in each situation.",
    },
    explanation:{
        title: "Before you begin, remember that: ",
        desc1: "There are no right or wrong answers, please answer honestly.",
        desc2: "Each question has a time limit, in case you don´t select one, the system will automatically advance to the next situation and you won´t be able to return. Therefore, it is very important that you keep your full attention on the test and respond as quickly as possible.",
        desc3: "A",
        desc4: "timeout bar ",
        desc5: "will be displayed at the bottom of the page. We suggest you keep an eye on it.",
    },
    firstEvaluation: {
        title: "Instructions",
        subtitle: "This test consists of knowing your reaction to certain situations.",
        desc: "On the following exercise you will find different scenarios with four possible answers. Please choose the phrase that best describes what you would do in each situation.",
        instructions: 'Please choose the phrase that best describes what you would do in each situation.',
        title_example: 'Situation example:',
        title_question:'Situation:',
        desc_question:'Please choose the phrase that best describes what you would do in each situation.',
        question_example: "You have just started a new job and it's your first day. At lunchtime, you go to the place designated by the company to eat your lunch. Once you have occupied a place, several collegues sit around you. What would you do?",
        answer1_example: 'You get up and look for another place to eat.',
        answer2_example: 'You use your cell phone to avoid talking to the group.',
        answer3_example: 'You try to talk with them to get to know them.',
        answer4_example: 'You finish eating quickly to retire.',
    },
    secondEvaluation: {
        title:'Instructions',
        subtitle:'This test consists of knowing your opinion about the following sentences. There are no right or wrong answers.',
        desc1:'All sentences have 4 possible answers: Strongly disagree, Disagree, Agree, and Strongly agree. Choose the option you most identify with. You can only choose one answer per sentence.',
        desc2:'Please answer honestly and don´t overthink your answers, we only want to know your opinion.',
        instruction: 'Instructions',
        instruction_description: 'Choose the answer you most identify with.',
        phrase: 'Phrase',
        totally_disagree: 'Strongly disagree',
        disagree: 'Disagree',
        okay: 'Agree',
        totally_agree: 'Strongly agree',
        exam_percentage:'Percentage of completion',
    },
    wait:{
        title: "Next evaluation",
        subtitle: "The test is almost over!",
        desc1: "Take a short breath, relax, and press."
    }, 
    thirdEvaluation:{
        title:'Instructions',
        i_desc1:'Examine the words in each series and select under the <strong>“+” column</strong> the box of the word that best describes your personality or behavior. Next, under the <strong>“-” column</strong>, choose the box of the word that least describes your personality or behavior.',
        i_desc2:'<strong>Remember not to do any other task, stay focused on this activity and avoid distractions.</strong>',
        desc: "Select below column",
        desc2: "what best describes you",
        desc3: "the least describes you",
        desc4: "Hover over the word to see its meaning",
        block: "Block",
        p_desc:"choose a word with + for what best describes it and a word with - for what least describes it.",
        p_desc_v2:"From each block, choose a word with + for what best describes it and a word with - for what least describes it.",
        p_desc2:"Press the word to see its meaning.",
        exam_percentage:'Percentage of completion',
    },
    final:{
        title: "This process is over!",
        desc1: "Thanks for your time.",
        desc2: "For more information, contact the person who assigned you the assessment.",
        desc3: "You can close this window"
    },
    message:{
        first_evaluation:'Selecting an option is required',
        second_evaluation:'Please answer all questions before continuing',
        second_evaluationP:'Pleasea answer the question before continuing',
        third_evaluation:'You have unfinished blocks', 
        third_evaluationP:"The block is not complete",
        third_evaluation_block:'There are blocks with errors.',
        error_responses:'Your answers have not been saved. Please try again later.',
        error_load_eval: "Oops! It seems that something went wrong while loading the evaluation. Would you like to try again?",
        instructions_retry: "Done! You can close this tab now. When you reopen the link, we'll reload your evaluation from this point."
    }
}

export default dictionary